import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ChartExportFacade } from '@mode/file-exports/domain';
import { FileExportDomain } from '@mode/shared/contract-common';
import { AnalyticsEvent } from '@mode/shared/util-segment';
import { Observable, first } from 'rxjs';

@Component({
  selector: 'mode-report-viewer-file-exports',
  templateUrl: './report-viewer-file-exports.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportViewerFileExportsComponent implements OnInit {
  @Input() drawerContext: string | undefined = 'embed'; // embed, dashboard

  downloads$: Observable<readonly FileExportDomain.FileExport[]> | undefined;
  visible$!: Observable<boolean>;
  expanded$!: Observable<boolean>;

  constructor(private chartExportFacade: ChartExportFacade) {}

  ngOnInit(): void {
    this.downloads$ = this.chartExportFacade.allExports$;
    this.visible$ = this.chartExportFacade.drawerIsOpen$;
    this.expanded$ = this.chartExportFacade.drawerIsExpanded$;
  }

  onDownloadCsv(id: string) {
    this.chartExportFacade.downloadChartDesignerCsv(id);
  }

  onRetryDownloadCsv(id: string) {
    this.chartExportFacade.retryExport(id);
  }

  onDeleteCsv(id: string) {
    this.chartExportFacade.removeExport(id);
  }

  onCloseDrawer() {
    this.chartExportFacade.updateDrawerState(false);
  }

  onExpandDrawer() {
    this.chartExportFacade.drawerIsExpanded$.pipe(first()).subscribe({
      next: (expanded) => {
        this.chartExportFacade.updateDrawerExpanded(!expanded);
      },
    });
  }
}
